import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusAdminProgramsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EpocusAdminProgramsQuery = { readonly __typename?: 'Query', readonly epocusPrograms: ReadonlyArray<{ readonly __typename?: 'EpocusProgram', readonly id: string, readonly name: string, readonly status: Types.EpocusProgramStatus, readonly dimseAeTitle?: string | null, readonly elephantFacilityId?: string | null }> };

export type EpocusAdminCreateProgramMutationVariables = Types.Exact<{
  input: Types.CreateEpocusProgramInput;
}>;


export type EpocusAdminCreateProgramMutation = { readonly __typename?: 'Mutation', readonly createEpocusProgram: { readonly __typename?: 'EpocusProgram', readonly id: string, readonly name: string, readonly status: Types.EpocusProgramStatus, readonly dimseAeTitle?: string | null } };

export type EpocusAdminProgramMembersQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusAdminProgramMembersQuery = { readonly __typename?: 'Query', readonly epocusProgramMembers: ReadonlyArray<{ readonly __typename?: 'EpocusProgramMembership', readonly id: string, readonly role: Types.EpocusRole, readonly status: Types.EpocusMembershipStatus, readonly user: { readonly __typename?: 'EpocusUser', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly telephone?: string | null, readonly status: Types.EpocusUserStatus } }> };

export type EpocusAdminAddProgramUserMutationVariables = Types.Exact<{
  input: Types.ProvisionEpocusProgramMemberInput;
}>;


export type EpocusAdminAddProgramUserMutation = { readonly __typename?: 'Mutation', readonly provisionEpocusProgramMember: { readonly __typename?: 'EpocusProgramMembership', readonly id: string } };

export type EpocusAdminProvisionUserMutationVariables = Types.Exact<{
  input: Types.ProvisionEpocusUserInput;
}>;


export type EpocusAdminProvisionUserMutation = { readonly __typename?: 'Mutation', readonly provisionEpocusUser: { readonly __typename?: 'EpocusUser', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string } };


export const EpocusAdminProgramsDocument = gql`
    query EpocusAdminPrograms {
  epocusPrograms {
    id
    name
    status
    dimseAeTitle
    elephantFacilityId
  }
}
    `;

/**
 * __useEpocusAdminProgramsQuery__
 *
 * To run a query within a React component, call `useEpocusAdminProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusAdminProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusAdminProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEpocusAdminProgramsQuery(baseOptions?: Apollo.QueryHookOptions<EpocusAdminProgramsQuery, EpocusAdminProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusAdminProgramsQuery, EpocusAdminProgramsQueryVariables>(EpocusAdminProgramsDocument, options);
      }
export function useEpocusAdminProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusAdminProgramsQuery, EpocusAdminProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusAdminProgramsQuery, EpocusAdminProgramsQueryVariables>(EpocusAdminProgramsDocument, options);
        }
export type EpocusAdminProgramsQueryHookResult = ReturnType<typeof useEpocusAdminProgramsQuery>;
export type EpocusAdminProgramsLazyQueryHookResult = ReturnType<typeof useEpocusAdminProgramsLazyQuery>;
export type EpocusAdminProgramsQueryResult = Apollo.QueryResult<EpocusAdminProgramsQuery, EpocusAdminProgramsQueryVariables>;
export const EpocusAdminCreateProgramDocument = gql`
    mutation EpocusAdminCreateProgram($input: CreateEpocusProgramInput!) {
  createEpocusProgram(input: $input) {
    id
    name
    status
    dimseAeTitle
  }
}
    `;
export type EpocusAdminCreateProgramMutationFn = Apollo.MutationFunction<EpocusAdminCreateProgramMutation, EpocusAdminCreateProgramMutationVariables>;

/**
 * __useEpocusAdminCreateProgramMutation__
 *
 * To run a mutation, you first call `useEpocusAdminCreateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusAdminCreateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusAdminCreateProgramMutation, { data, loading, error }] = useEpocusAdminCreateProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusAdminCreateProgramMutation(baseOptions?: Apollo.MutationHookOptions<EpocusAdminCreateProgramMutation, EpocusAdminCreateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusAdminCreateProgramMutation, EpocusAdminCreateProgramMutationVariables>(EpocusAdminCreateProgramDocument, options);
      }
export type EpocusAdminCreateProgramMutationHookResult = ReturnType<typeof useEpocusAdminCreateProgramMutation>;
export type EpocusAdminCreateProgramMutationResult = Apollo.MutationResult<EpocusAdminCreateProgramMutation>;
export type EpocusAdminCreateProgramMutationOptions = Apollo.BaseMutationOptions<EpocusAdminCreateProgramMutation, EpocusAdminCreateProgramMutationVariables>;
export const EpocusAdminProgramMembersDocument = gql`
    query EpocusAdminProgramMembers($programId: ID!) {
  epocusProgramMembers(programId: $programId) {
    id
    role
    status
    user {
      id
      firstName
      lastName
      email
      telephone
      status
    }
  }
}
    `;

/**
 * __useEpocusAdminProgramMembersQuery__
 *
 * To run a query within a React component, call `useEpocusAdminProgramMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusAdminProgramMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusAdminProgramMembersQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusAdminProgramMembersQuery(baseOptions: Apollo.QueryHookOptions<EpocusAdminProgramMembersQuery, EpocusAdminProgramMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusAdminProgramMembersQuery, EpocusAdminProgramMembersQueryVariables>(EpocusAdminProgramMembersDocument, options);
      }
export function useEpocusAdminProgramMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusAdminProgramMembersQuery, EpocusAdminProgramMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusAdminProgramMembersQuery, EpocusAdminProgramMembersQueryVariables>(EpocusAdminProgramMembersDocument, options);
        }
export type EpocusAdminProgramMembersQueryHookResult = ReturnType<typeof useEpocusAdminProgramMembersQuery>;
export type EpocusAdminProgramMembersLazyQueryHookResult = ReturnType<typeof useEpocusAdminProgramMembersLazyQuery>;
export type EpocusAdminProgramMembersQueryResult = Apollo.QueryResult<EpocusAdminProgramMembersQuery, EpocusAdminProgramMembersQueryVariables>;
export const EpocusAdminAddProgramUserDocument = gql`
    mutation EpocusAdminAddProgramUser($input: ProvisionEpocusProgramMemberInput!) {
  provisionEpocusProgramMember(input: $input) {
    id
  }
}
    `;
export type EpocusAdminAddProgramUserMutationFn = Apollo.MutationFunction<EpocusAdminAddProgramUserMutation, EpocusAdminAddProgramUserMutationVariables>;

/**
 * __useEpocusAdminAddProgramUserMutation__
 *
 * To run a mutation, you first call `useEpocusAdminAddProgramUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusAdminAddProgramUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusAdminAddProgramUserMutation, { data, loading, error }] = useEpocusAdminAddProgramUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusAdminAddProgramUserMutation(baseOptions?: Apollo.MutationHookOptions<EpocusAdminAddProgramUserMutation, EpocusAdminAddProgramUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusAdminAddProgramUserMutation, EpocusAdminAddProgramUserMutationVariables>(EpocusAdminAddProgramUserDocument, options);
      }
export type EpocusAdminAddProgramUserMutationHookResult = ReturnType<typeof useEpocusAdminAddProgramUserMutation>;
export type EpocusAdminAddProgramUserMutationResult = Apollo.MutationResult<EpocusAdminAddProgramUserMutation>;
export type EpocusAdminAddProgramUserMutationOptions = Apollo.BaseMutationOptions<EpocusAdminAddProgramUserMutation, EpocusAdminAddProgramUserMutationVariables>;
export const EpocusAdminProvisionUserDocument = gql`
    mutation EpocusAdminProvisionUser($input: ProvisionEpocusUserInput!) {
  provisionEpocusUser(input: $input) {
    id
    firstName
    lastName
    email
  }
}
    `;
export type EpocusAdminProvisionUserMutationFn = Apollo.MutationFunction<EpocusAdminProvisionUserMutation, EpocusAdminProvisionUserMutationVariables>;

/**
 * __useEpocusAdminProvisionUserMutation__
 *
 * To run a mutation, you first call `useEpocusAdminProvisionUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusAdminProvisionUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusAdminProvisionUserMutation, { data, loading, error }] = useEpocusAdminProvisionUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusAdminProvisionUserMutation(baseOptions?: Apollo.MutationHookOptions<EpocusAdminProvisionUserMutation, EpocusAdminProvisionUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusAdminProvisionUserMutation, EpocusAdminProvisionUserMutationVariables>(EpocusAdminProvisionUserDocument, options);
      }
export type EpocusAdminProvisionUserMutationHookResult = ReturnType<typeof useEpocusAdminProvisionUserMutation>;
export type EpocusAdminProvisionUserMutationResult = Apollo.MutationResult<EpocusAdminProvisionUserMutation>;
export type EpocusAdminProvisionUserMutationOptions = Apollo.BaseMutationOptions<EpocusAdminProvisionUserMutation, EpocusAdminProvisionUserMutationVariables>;